module.exports = {"welcome":"Welcome to your new project with Get It Built!","excited":"We’re thrilled to work with you!","thanks":"Thank you!","problem":"Uh-oh! 😳","thanksDetail":"We will get back to you soon with details on how we can help.","problemDetail":"Something went wrong.","confirm":"I understand","tryAgain":"Try Again!","formLabelName":"Name"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy/general.json
// module id = 85
// module chunks = 0